import React from 'react'
import './spinner.scss'

export default function Spinner(props) {
    return <div className={`loader small`}>Loading...</div>
}
